const translateConfig = require('./translate')
const normalizeConfig = require('./normalize')

function toEntity (doc, { normalize }) {
  const translated = translateConfig(doc)
  return normalize ? normalizeConfig(translated) : translated
}

module.exports = toEntity
